var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 91,
    viewBox: "0 0 85 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5303 2.00084C39.2341 -0.666948 45.0295 -0.666947 49.7333 2.00084L76.6621 17.2736C81.3659 19.9414 84.2636 24.8717 84.2636 30.2072V60.7528C84.2636 66.0883 81.3659 71.0186 76.6621 73.6864L49.7333 88.9592C45.0295 91.6269 39.2341 91.6269 34.5303 88.9592L7.6015 73.6864C2.89768 71.0186 0 66.0883 0 60.7528V30.2072C0 24.8717 2.89768 19.9414 7.6015 17.2736L34.5303 2.00084Z",
    fill: "#152342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9956 59.2139C23.9956 60.1043 23.3719 60.8261 22.6026 60.8261H18.1341C17.3648 60.8261 16.7411 60.1043 16.7411 59.2139L16.7411 33.1569C16.7411 31.4874 17.9105 30.134 19.353 30.134H22.6026C23.3719 30.134 23.9956 30.8558 23.9956 31.7462V59.2139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4025 37.3884C25.9978 37.3884 25.6697 36.7648 25.6697 35.9954L25.6697 31.527C25.6697 30.7576 25.9978 30.1339 26.4025 30.1339L38.2466 30.134C39.0054 30.134 39.6206 31.3033 39.6206 32.7459V35.9954C39.6206 36.7648 39.2925 37.3884 38.8878 37.3884H26.4025Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4025 53.5715C25.9978 53.5715 25.6697 54.1952 25.6697 54.9645V59.433C25.6697 60.2023 25.9978 60.826 26.4025 60.826H38.2466C39.0054 60.826 39.6206 59.6566 39.6206 58.2141V54.9646C39.6206 54.1952 39.2925 53.5715 38.8878 53.5715H26.4025Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3394 59.2139C51.3394 60.1043 50.7157 60.8261 49.9463 60.8261H45.4779C44.7085 60.8261 44.0849 60.1043 44.0849 59.2139V33.1569C44.0849 31.4874 45.2543 30.134 46.6968 30.134H49.9463C50.7157 30.134 51.3394 30.8558 51.3394 31.7462V59.2139Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7464 37.3884C53.3416 37.3884 53.0136 36.7648 53.0136 35.9954V31.527C53.0136 30.7576 53.3416 30.1339 53.7464 30.1339L65.5904 30.134C66.3493 30.134 66.9645 31.3033 66.9645 32.7459V35.9954C66.9645 36.7648 66.6364 37.3884 66.2317 37.3884H53.7464Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7464 53.5715C53.3417 53.5715 53.0136 54.1952 53.0136 54.9645V59.433C53.0136 60.2023 53.3416 60.826 53.7464 60.826H65.5904C66.3493 60.826 66.9645 59.6566 66.9645 58.2141V54.9646C66.9645 54.1952 66.6364 53.5715 66.2317 53.5715H53.7464Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7464 41.8528C53.3417 41.8528 53.0136 42.4765 53.0136 43.2458V47.7142C53.0136 48.4836 53.3416 49.1073 53.7464 49.1073H65.5904C66.3493 49.1073 66.9645 47.9379 66.9645 46.4954V43.2458C66.9645 42.4765 66.6364 41.8528 66.2317 41.8528H53.7464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentExpress);
export default __webpack_public_path__ + "static/media/content-express.31359509f63e03ae53a06251580df0fa.svg";
export { ForwardRef as ReactComponent };